<template>
	<TermsAndConditions :is-full-width="false">
		<div class="mt-4 flex flex-col space-y-2">
			<div class="items-top flex gap-1">
				<span class="text-xsss">1</span>
				<span>
					'Upfront' and 'Initial' four weeks fee are non-refundable
					except in certain circumstances, including if there is a
					major failure under the Australian Consumer Law.
					<CarbarLink
						href="/terms-and-conditions/car-subscription"
						font-size="text-xsm"
						text="Car Subscription Terms & Conditions"
						target="_blank"
						:hover-color="whitelabel?.styles?.button?.hover"
						:underline-color="whitelabel?.styles?.button?.underline"
					/>
					<span v-if="isGroupSubs">
						and
						<CarbarLink
							href="/terms-and-conditions/group-subscription"
							font-size="text-xsm"
							text="Group Subscription Terms & Conditions"
							target="_blank"
							:hover-color="whitelabel?.styles?.button?.hover"
							:underline-color="
								whitelabel?.styles?.button?.underline
							"
						/>
					</span>
					apply.
				</span>
			</div>
			<div v-if="hasMinTermPlans" class="items-top flex gap-1">
				<span class="text-xsss">2</span>
				<span>
					During the Minimum Subscription Period, early termination,
					exchanges, or returns of the car is not possible if you
					change your mind.
				</span>
			</div>
			<div v-if="showMinTermFootnote" class="items-top flex gap-1">
				<span class="text-xsss">3</span>
				<span>
					1 month free will be applied at the end of the minimum term
					period.
				</span>
			</div>
			<div v-if="partnerKey === 'carsales'" class="items-top flex gap-1">
				<span class="text-xsm">*</span>
				<span>
					carsales may receive a commission if you subscribe to carbar
					through this site.
				</span>
			</div>
		</div>
	</TermsAndConditions>
</template>

<script setup>
import TermsAndConditions from '@/components/fineprint/TermsAndConditions.vue'
import CarbarLink from '@/components/links/CarbarLink.vue'

const props = defineProps({
	servicePlans: {
		type: Object,
		default: () => ({}),
		required: false,
	},
	partnerKey: {
		type: String,
		required: false,
		default: null,
	},
	isGroupSubs: {
		type: Boolean,
		required: false,
		default: false,
	},
})

const { whitelabel } = useWhitelabelsStyles(props.partnerKey)

const hasMinTermPlans = computed(() => {
	return Object.keys(props.servicePlans || {}).length > 1
})

const showMinTermFootnote = computed(() => {
	const discount = props.servicePlans?.subs_12m_plan?.discount

	return !!discount
})
</script>
